// extracted by mini-css-extract-plugin
export var borderTop = "navigation-customer-hs-module--border-top--d613c";
export var iconLogin = "navigation-customer-hs-module--icon-login--15b7d";
export var iconLogout = "navigation-customer-hs-module--icon-logout--913f2";
export var navigationItem = "navigation-customer-hs-module--navigation-item--a1aff";
export var navigationItemActive = "navigation-customer-hs-module--navigation-item-active--052b2";
export var navigationItemHeadline = "navigation-customer-hs-module--navigation-item-headline--b3f4f";
export var navigationItemWrapper = "navigation-customer-hs-module--navigation-item-wrapper--a30ca";